"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var filtersReducer = function filtersReducer(state, action) {
  // console.log('ACTION RECEIVED filtersReducer', state, action)
  switch (action.type) {
    case 'toggleFilter':
      return _objectSpread(_objectSpread({}, state), {}, {
        filters: _objectSpread(_objectSpread({}, state.filters), {}, _defineProperty({}, action.name, state.filters[action.name].includes(action.option) ? state.filters[action.name].filter(function (ex) {
          return ex !== action.option;
        }) : [state.filters[action.name], action.option].flat(Infinity)))
      });

    case 'flipSwitch':
      return _objectSpread(_objectSpread({}, state), {}, {
        switches: _objectSpread(_objectSpread({}, state.switches), {}, _defineProperty({}, action.name, !state.switches[action.name]))
      });

    case 'flipToggle':
      return _objectSpread(_objectSpread({}, state), {}, {
        toggles: _objectSpread(_objectSpread({}, state.toggles), {}, _defineProperty({}, action.name, !state.toggles[action.name]))
      });

    case 'reset':
      return _objectSpread(_objectSpread({}, state.initialState), {}, {
        initialState: state.initialState
      });

    case 'updateSearchString':
      return _objectSpread(_objectSpread({}, state), {}, {
        searchString: action.searchString
      });

    case 'setSortName':
      return _objectSpread(_objectSpread({}, state), {}, {
        sortName: action.sortName
      });

    case 'toggleSort':
      return _objectSpread(_objectSpread({}, state), {}, {
        reverseSort: !state.reverseSort
      });

    default:
      return state;
  }
};

var useFilterReducer = function useFilterReducer(filterNames, switches, toggles) {
  var seededOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var initialFilters = filterNames.reduce(function (acc, name) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, []));
  }, {});
  var initialSwitches = switches.reduce(function (acc, s) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, s.name, false));
  }, {});
  var initialToggles = toggles.reduce(function (acc, s) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, s.name, false));
  }, {});
  var initialState = {
    searchString: seededOptions.searchString || '',
    sortName: seededOptions.sortName || '',
    reverseSort: seededOptions.reverseSort ? true : false,
    filters: initialFilters,
    switches: initialSwitches,
    toggles: initialToggles
  };

  var _useReducer = (0, _react.useReducer)(filtersReducer, _objectSpread(_objectSpread({}, initialState), {}, {
    filters: _objectSpread(_objectSpread({}, initialState.filters), seededOptions.filters || {}),
    switches: _objectSpread(_objectSpread({}, initialState.switches), seededOptions.switches || {}),
    toggles: _objectSpread(_objectSpread({}, initialState.toggles), seededOptions.toggles || {}),
    initialState: initialState
  })),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  return [state, dispatch];
};

var _default = useFilterReducer;
exports.default = _default;